import React from 'react'
import { useLocation, useParams, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { userOrganizationsSelector } from '../../store/selectors/userSelector'

const DealershipAgencyRedirector = () => {
  const { dealership_id } = useParams()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const nextPath = queryParams.get('next') // e.g., "customers/sources/details/{{customer_source_id}}"
  const organizations = useSelector(userOrganizationsSelector)

  // Find the first agency (organization) that includes the specified dealership.
  const selectedAgency = organizations?.find((org) =>
    org.dealerships.find((d) => d.id === Number(dealership_id)),
  )

  if (selectedAgency) {
    // Build the base URL using the agency's ID and the dealership ID.
    let targetUrl = `/dashboard/agency/${selectedAgency.id}/dealership/${dealership_id}`

    // Append the additional path if provided.
    if (nextPath) {
      // Ensure there's a slash between the base and the next path.
      targetUrl += `/${nextPath}`
    }

    return <Navigate to={targetUrl} replace />
  }

  // Fallback: If no agency is found, redirect to the main dashboard.
  return <Navigate to="/dashboard" replace />
}

export default DealershipAgencyRedirector
